import React from "react";
import ReactDOM from "react-dom";
import { ReactRender } from "@/components/ReactRender";
import ModalLoadingIndicator from "./ModalLoadingIndicator";

export let hideLoadingIndicator = () => {};

function showLoadingIndicator(options) {
  const container = document.createElement("div");
  document.body.appendChild(container);

  const unMount = () => {
    ReactDOM.unmountComponentAtNode(container);
    try {
      container.parentElement?.removeChild(container);
    } catch (e) {
      console.warn(e);
    }
  };

  const handleCancel = () => {
    unMount();
    hideLoadingIndicator = () => {};
    return options?.onClose?.();
  };

  hideLoadingIndicator = handleCancel;

  ReactRender(<ModalLoadingIndicator onClose={handleCancel} />, container);
}

export default showLoadingIndicator;
